import styled, { keyframes } from 'styled-components';
import dt from '../../../shared/theme';
import { IconedButtonStyles } from '../iconed-button';

const delay = 300;
const stages = [
  { duration: 100, timing: 'ease-out' },
  { duration: 400, timing: 'cubic-bezier(0.42, 0, 0.58, 1)' },
];

const duration = delay + stages[0].duration + stages[1].duration;
const step1 = `${stages[0].duration}ms ${stages[0].timing}`;
const step2 = `${stages[1].duration}ms ${stages[1].timing} ${stages[0].duration + delay}ms`;

const StaticButton = styled.button`
  ${IconedButtonStyles};
  width: 132px;
  align-items: center;
  border-width: 1px;
  padding: 4px 0 4px 4px;
  outline: none;

  &,
  &:hover {
    border-width: 1px;
    transition: none;
    background-color: white;
    border: 1px solid ${props => dt(props).theme.secondaryColor};
    color: ${props => dt(props).theme.bodyColor};
  }

  & > .icon-box {
    display: flex;
    height: 26px;
    width: 26px;
    justify-content: center;
    align-items: center;

    .icon-lw-user-check {
      font-size: 20px;
      background-color: white;
    }
  }

  & > .text-box {
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    height: 26px;
    font-size: ${props => (dt(props).theme.isLarge ? 14 : 12)}px;
    line-height: 34px;

    > .followed {
      color: ${props => dt(props).theme.bodyColor};
    }
  }
`;

const toPrimaryColor = keyframes`
  from {
    border-color: #d9c182;
    background-color: #d9c182;
  }
  to {
    border-color: #c19d3f;
    background-color: #c19d3f;
  }
`;

const toStaticColor = keyframes`
  from {
    border-color: #c19d3f;
    background-color: #c19d3f;
  }
  to {
    border-color: #8ea3b5;
    background-color: #ffffff;
  }
`;

const Button = styled(StaticButton)`
  border: 1px solid #d9c182;
  color: white;
  background-color: #d9c182;

  &:hover {
    border-color: #d3b66c;
    background-color: #d3b66c;
    color: white;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  & > .icon-box {
    border-radius: 2px;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow: hidden;
    height: 26px;
    width: 26px;
    background-color: ${props => dt(props).theme.primaryColor};

    > .icon-full-size {
      font-size: 16px;
      padding: 5px;
    }

    > .icon-lw-plus,
    > .fa-check {
      z-index: 20;
    }

    > .icon-lw-user-check {
      z-index: 19;
      position: relative;
      left: ${props => (dt(props).theme.isLarge ? 0 : -2.5)}px;
      top: -54px;
      font-size: 20px;
      background-color: transparent;
      color: ${props => dt(props).theme.bodyColor};
    }
  }

  /* stylelint-disable-next-line no-descending-specificity */
  & > .text-box {
    > .followed {
      transform: translateX(1.5px);
      opacity: 0;
    }

    > .not-followed {
      position: relative;
      margin-top: -34px;
    }
  }

  /* transitions/animations */
  &&&& {
    .icon-box {
      transition: background-color 50ms linear ${stages[0].duration + 50}ms;

      .icon-lw-plus {
        opacity: 1;
        transition: opacity ${step1};
      }

      .fa-check {
        opacity: 1;
        margin-top: 0px;
        transform: translateX(0%) scale(1);
        transition: margin-top ${step1}, transform ${step2}, opacity ${step2}, color ${step2};
      }

      .icon-lw-user-check {
        opacity: 0;
        margin-top: 0px;
        transition: opacity ${step2};
      }
    }

    .text-box {
      .followed {
        opacity: 0;
        transition: opacity ${step2};
      }

      .not-followed {
        opacity: 1;
        transition: opacity ${step2};
      }
    }
  }
  &&&&.playing {
    animation: ${toPrimaryColor} ${step1} both, ${toStaticColor} ${step2} both;

    .icon-box {
      background-color: transparent;

      .icon-lw-plus {
        opacity: 0;
      }

      .fa-check {
        color: #19202d;
        margin-top: -27px;
        transform: translateX(30%) scale(0.5);
        opacity: 0;
      }

      .icon-lw-user-check {
        opacity: 1;
        margin-top: 27px;
      }
    }

    .text-box {
      margin-left: -3px;
      .followed {
        opacity: 1;
      }

      .not-followed {
        margin-left: 3px;
        opacity: 0;
      }
    }
  }
`;

export {
  Button,
  StaticButton,
  duration,
};
